export default __webpack_public_path__ + "MediaExplenation.2f6f9b4.png";